export const alignItems = (verticalAlign?: string, centered?: boolean) => {
  if (verticalAlign === "top") {
    return "start";
  }
  if (verticalAlign === "bottom") {
    return "end";
  }
  if (verticalAlign === "middle") {
    return "center";
  }
  if (centered) {
    return "center";
  }
  return "stretch";
};

export const textAlignCss = (textAlign?: string) =>
  textAlign === "justified" ? "justify" : textAlign || "left";

export const gridTemplate = (columns: number) =>
  `repeat(${Math.max(1, columns)}, minmax(0, 1fr))`;

export const gapCss = ($gap?: string | number) => {
  if ($gap === undefined || $gap === null) {
    return "1rem";
  }
  return typeof $gap === "number" ? `${$gap}px` : $gap;
};
